import React,{useState, useEffect} from "react"
import { AutoSearchDropdown, InputBox, SelectDropDown, TextArea } from "../../../components/Custom"
import { H4FormLabel } from "../../../theme/Theme"
import { Box, Grid, Typography, CircularProgress, Button, IconButton, InputAdornment} from "@mui/material"
import ThemeColor from "../../../theme/ThemeColor"
import DisplayError from "../../../validation/DisplayError"
import HeaderName from "../../../components/Custom/HeaderName"
import { useLocation, useNavigate } from "react-router"
import validate from "../../../validation/validation";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux"
import { createdeliveryBoyDetails, getBranchList, updatedeliveryBoyDetails } from "../../../redux/Thunk/branchThunk";
import { statusList } from "../../utils/constant";
import { createOfficeDetails, getOfficeList, updateOfficeDetails } from "../../../redux/Thunk/officeThunk"
import { EyeCloseIcon, EyeOpenIcon } from "../../../components/Icons";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 200,
        },
    },
};

const NewDeliveryBoy = () =>{
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const {officeList} = useSelector((state) => state.office)
    const {branchList} = useSelector((state)=> state.branch)
    const {state} = useLocation()
    const [error, setError] = useState([]);
    const [loader, setLoader]= useState(false)
    const [editdeliveryBoyDetails, setEditdeliveryBoyDetails] = useState(state?.editDetails ? state?.editDetails :{})
    const [deliveryBoyDetails, setDeliveryBoyDetails] = useState({
        OfficeId:'',
        AdminName:'',
        Email:'',
        Mobile:'',
        // BranchName:'',
        Status: statusList[0]?.value,
        Address:'',
        Role:'DeliveryBoy',
        Password:'',
    })
    const [showPassword, setShowPassword]= useState(true)
    const [filteredBranches, setFilteredBranches] = useState([]);   // Filter the branch to office

    useEffect(() => {
        dispatch(getOfficeList({page:1, limit: 10000,search:"", role:'OfficeAdmin'}))
        dispatch(getBranchList({page:1, limit: 10000}))
        if(Object.keys(editdeliveryBoyDetails).length > 0){ 
            setDeliveryBoyDetails({
                OfficeId: editdeliveryBoyDetails?.OfficeId || '',
                AdminName: editdeliveryBoyDetails?.AdminName || '',
                Email: editdeliveryBoyDetails?.Email || '',
                Mobile: editdeliveryBoyDetails?.Mobile?.toString() || '',
                // BranchName: editdeliveryBoyDetails?.BranchName || '',
                Status: editdeliveryBoyDetails?.Status || '',
                Address: editdeliveryBoyDetails?.Address || '',
                Role:editdeliveryBoyDetails?.Role || '',
            });
            // Filter branches initially
            const filtered = branchList?.data?.filter(branch => branch.OfficeId === editdeliveryBoyDetails?.OfficeId) || [];
            setFilteredBranches(filtered);
        } 
    },[])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDeliveryBoyDetails(prev => ({
            ...prev,
            [name]: value,
            // Reset BranchName if office changes
            // ...(name === 'OfficeId' ? { BranchName: '' } : {})
        }));
    };

    let check_first_digit = deliveryBoyDetails?.Mobile ? deliveryBoyDetails?.Mobile[0] : 0 

    let validation_input = [  
        {tagid:'AdminName', text:deliveryBoyDetails?.AdminName ??'', required: true, regex_name:'text', errmsg: 'Please Enter Name.', allow_numbers: false, other_chars: ' ', min:3, max: 50} ,
        {tagid:'OfficeId', text:deliveryBoyDetails?.OfficeId ??'', regex_name:'free_text', required: true, errmsg: 'Please Select Office Name.', min:1, max: 50},
        {tagid:'Status', text:deliveryBoyDetails?.Status ??'', required: true, regex_name:'free_text', errmsg: 'Please Select Status.', min:1, max:50} ,
        // {tagid:'BranchName', text:deliveryBoyDetails?.BranchName ??'', required: true, regex_name:'free_text', errmsg: 'Please Enter Branch Name.', min:1, max:50} ,
        {tagid:'Email', text: deliveryBoyDetails?.Email ??'', regex_name:'email', required: true, errmsg:'Please Enter Valid Email.'}, 
        Number(check_first_digit) <= 5 ? {tagid:'Mobile', text:deliveryBoyDetails?.Mobile, required:true, regex_name: 'exact_x_digits', errmsg:'Please Enter Valid Number.' } : {tagid:'Mobile', text:deliveryBoyDetails?.Mobile, regex_name: 'exact_x_digits', required: true, errmsg:'Please Enter Valid Number.', x_count:10 },
        {tagid:'Address', text:deliveryBoyDetails?.Address ??'', required: true, regex_name:'free_text', errmsg: 'Please add the Address between 30 to 150 characters.', min:30, max:150} ,
        Object.keys(editdeliveryBoyDetails).length === 0 ? {tagid: 'Password', text: deliveryBoyDetails?.Password, required: true, regex_name:'password', errmsg: "Password must contains at least 8 characters, Including 1 UPPER case, number and special characters."} :<></>,  
    ] 

     const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    // Create and update Delivery Boy details
    const onClickSubmitForm = () =>{
        if(validate(validation_input)?.length == 0){
            setLoader(true)
           if(Object.keys(editdeliveryBoyDetails)?.length == 0 ){ 
                // Create Delivery Boy Details 
                deliveryBoyDetails.OfficeName = officeList?.data?.find((o) => o.OfficeId === deliveryBoyDetails?.OfficeId)?.OfficeName
                dispatch(createOfficeDetails(deliveryBoyDetails)).then((res)=>{
                    if(res.payload.success === false){
                        sweetalert('error', res?.payload?.message)
                    }else{
                        sweetalert('success', res?.payload?.message)
                        setDeliveryBoyDetails({
                            OfficeId:'',
                            AdminName:'',
                            Email:'',
                            Mobile:'',
                            // BranchName:'',
                            Address:'',
                            Role:'DeliveryBoy',
                            Password:'',
                            status:''
                        })
                        navigate("/dashboard/deliveryboylist")
                    }  
                    setLoader(false)    
                }) 
            }else{   
                deliveryBoyDetails.DeliveryBoyId = editdeliveryBoyDetails?.DeliveryBoyId
                deliveryBoyDetails.OfficeName = officeList?.data?.find((o) => o.OfficeId === deliveryBoyDetails?.OfficeId)?.OfficeName
                // Update Delivery Boy details
                dispatch(updateOfficeDetails(deliveryBoyDetails)).then((res)=>{
                    if(res.payload.success === false){
                        sweetalert('error', res?.payload?.message)
                    }else{
                        sweetalert('success', res?.payload?.message)
                        setDeliveryBoyDetails({
                            OfficeId:'',
                            AdminName:'',
                            Email:'',
                            Mobile:'',
                            // BranchName:'',
                            Address:'',
                            Role:'DeliveryBoy',
                            Password:'',
                            status:''
                        })
                        navigate("/dashboard/deliveryboylist")
                    }  
                    setLoader(false)    
                }) 
            }
        }else{
            setError(validate(validation_input))
        }
    }

    const sweetalert = (variant, text) => {
        Swal.fire({
            icon: variant==='error' ? 'error' :'success',
            title: text , 
            button: "Ok!",
        }); 
    }

    return(
        <>
            <div style={{display:'flex', flexDirection:'column', flexGrow: 1}}>
                <HeaderName headerName={Object.keys(editdeliveryBoyDetails).length > 0 ? 'Edit Delivery Boy' :'Add Delivery Boy'} newForm = {false} onClickBackButton={()=> navigate("/dashboard/deliveryboylist")} />
                <Box style={{backgroundColor:'#FFFFFF', margin:'5px 30px 5px 10px', border:'1px solid #FFFFF', borderRadius:'30px'}}>    
                    <Grid container spacing={2} style={{ display: 'flex', padding:'20px 20px', flexDirection: 'row', alignItems: 'start', justifyContent: 'start' }}>
                        {/* Render input fields for 'Branch' */}
                            <Grid size={{ xs: 12, sm: 4, md: 4, lg:4 }}>
                                <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Office Name<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                                <AutoSearchDropdown
                                    id="OfficeId"
                                    name="OfficeId"
                                    placeholder="Select Office Name"
                                    onChange={handleChange}
                                    value={
                                        officeList?.data?.find((o) => o.OfficeId === deliveryBoyDetails?.OfficeId) 
                                          ? {
                                              label: officeList?.data?.find((o) => o.OfficeId === deliveryBoyDetails?.OfficeId)?.OfficeName,
                                              value: deliveryBoyDetails?.OfficeId
                                            } 
                                          : null
                                      }
                                    options={officeList?.data?.map((name) => ({value: name?.OfficeId, label: name?.OfficeName}))}
                                    sx={{borderRadius: '10px', mt:0.5, background: '#ffffff' }}
                                />
                                <DisplayError error={error} fortagid='OfficeId'/>
                            </Grid>

                            {/* <Grid size={{ xs: 12, sm: 4, md:4, lg:4}}>
                                <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Branch Name<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                                 <AutoSearchDropdown
                                    id="BranchName"
                                    name="BranchName"
                                    placeholder="Enter Branch Name"
                                    onChange={handleChange}
                                    value={
                                        filteredBranches.find(branch => branch.branchName === deliveryBoyDetails?.BranchName)
                                        ? {
                                            label: filteredBranches.find(branch => branch.branchName === deliveryBoyDetails?.BranchName)?.branchName,
                                            value: deliveryBoyDetails?.BranchName,
                                            }
                                        : null
                                    }
                                    options={filteredBranches.map(branch => ({ value: branch.branchName, label: branch.branchName }))}
                                    sx={{ borderRadius: '10px', mt: 0.5, background: '#ffffff' }}
                                />

                                <DisplayError error={error} fortagid='BranchName' />
                            </Grid> */}

                            <Grid size={{ xs: 12, sm: 4, md:4, lg:4}}>
                                <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>Name<span style={{ color: '#FF0000', fontWeight: 700 }}>*</span></H4FormLabel>
                                <InputBox sx={{ borderRadius: '10px', backgroundColor: '#FFFFFF', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                    placeholder="Enter Name"
                                    name='AdminName'
                                    value={deliveryBoyDetails?.AdminName}
                                    onChange={handleChange}
                                />
                                <DisplayError error={error} fortagid='AdminName' />
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4}}>
                                <H4FormLabel sx={{color: ThemeColor.palette.InputTextColor}}>Email<span style={{color:'#FF0000', fontWeight:700}}>*</span></H4FormLabel>
                                <InputBox sx={{ borderRadius: '10px', backgroundColor: '#ffffff', color: ThemeColor.palette.InputTextColor, border: "1px solid rgba(0, 0, 0, 0.3)", fontSize: '14px', width: '100%', p: 0.1, pl: 2 }}
                                    placeholder='Enter Email'
                                    name='Email'
                                    value={deliveryBoyDetails?.Email}
                                    onChange={handleChange}
                                />
                                <DisplayError error={error} fortagid='Email'/>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4}}>
                                <H4FormLabel sx={{color: ThemeColor.palette.InputTextColor}}>Mobile Number<span style={{color:'#FF0000', fontWeight:700}}>*</span></H4FormLabel>
                                <InputBox sx={{borderRadius:'10px', color:ThemeColor.palette.InputTextColor, border:"1px solid rgba(0, 0, 0, 0.3)", fontSize:'14px', width:'100%', p:0.1, pl:2}}  
                                    placeholder ="Enter Mobile Number" name='Mobile' value={deliveryBoyDetails?.Mobile} 
                                    onChange={(e)=>{
                                        if(e.target.value.length <=10)handleChange(e)
                                    }} 
                                    onKeyPress={(e) => {
                                        const keyCode = e.keyCode || e.which;
                                        const keyValue = String.fromCharCode(keyCode);
                                        const numericRegex = /^[0-9]*$/;
                                        if (!numericRegex.test(keyValue)) {
                                        e.preventDefault();
                                        }
                                    }} 
                                /> 
                                <DisplayError error={error} fortagid='Mobile'/>
                            </Grid>

                        {/* ========== Password ============== */}
                            {Object.keys(editdeliveryBoyDetails).length > 0 ? <><Grid sx={{mb:2}}></Grid> </> :
                                <><Grid size={{ xs: 12, sm: 4, md: 4, lg: 4}}>
                                <H4FormLabel sx={{color: ThemeColor.palette.InputTextColor}}>Password<span style={{color:'#FF0000', fontWeight:700}}>*</span></H4FormLabel>
                                <InputBox onPaste={(e) => e.preventDefault()} onCopy={(e) => e.preventDefault()} name='Password' type={showPassword ?'password': 'text'} value={deliveryBoyDetails?.Password} onChange={handleChange} sx={{width:'100%', border: "1px solid rgba(0, 0, 0, 0.3)", borderRadius:'10px', p:0.1, pl:1}} placeholder ="Password" endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton style={{ml:1}}  aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
                                            {showPassword ? <EyeCloseIcon /> : <EyeOpenIcon />}
                                        </IconButton> 
                                    </InputAdornment>
                                    }/>
                                <DisplayError error={error} fortagid='Password'/>
                            </Grid>
                            </>}

                            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4}}>
                                <H4FormLabel sx={{color: ThemeColor.palette.InputTextColor}}>Status<span style={{color:'#FF0000', fontWeight:700}}>*</span></H4FormLabel>
                                <SelectDropDown
                                    id="Status"
                                    name="Status"
                                    placeholder="Enter Status"
                                    onChange={handleChange}
                                    Default={"Active"}
                                    value={deliveryBoyDetails?.status}
                                    options={statusList}
                                    sx={{mt:0.5, height: '50px', borderRadius: '10px', background: '#ffffff' }}
                                />
                                <DisplayError error={error} fortagid='Status'/>
                            </Grid>

                            <Grid size={{ xs: 12, sm: 12, md: 12, lg:12}}>
                                <H4FormLabel sx={{mb:0.5, color: ThemeColor.palette.InputTextColor}}>Address<span style={{color:'#FF0000', fontWeight:700}}>*</span></H4FormLabel>
                                <TextArea id='address' value={deliveryBoyDetails?.Address} onChange={handleChange} name='Address' style={{height:'40px'}} placeholder ="Enter Address"></TextArea>  
                                <DisplayError error={error} fortagid='Address'/>
                            </Grid>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 10, md: 10, lg:12 }} style={{marginTop:'10px', display:'flex', justifyContent:'center'}}>
                        <Button
                            id="save"
                            variant="contained"
                            disabled={loader}
                            onClick={onClickSubmitForm}
                            sx={{color: '#FFFFFF', backgroundColor: '#04AB44',
                                '&:hover': { backgroundColor: '#04AB44', color: '#FFFFFF' },
                                fontSize: '16px', fontWeight: '500', borderRadius:"10px", pl:5, pr:5, textTransform: 'none', boxShadow:'0px 4px 6px #e1e1e1', mb:4, letterSpacing:'1px'
                            }}>
                            {loader ? <CircularProgress size={20} color="inherit" /> : 'Save'}
                        </Button>
                    </Grid>
                </Box>
            </div>     
        </>
    )
}

export default NewDeliveryBoy